
import React, { useState, useEffect } from 'react';
import {
  Button,
  Container,
  Box,
  Modal,
  Tooltip,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  useTheme,
  styled,
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

// Custom scrollbar styled component for modal
const CustomTableScrollbar = styled('div')(({ theme }) => ({
  overflowY: 'auto',
  backgroundColor: theme.palette.background.paper,
  '&::-webkit-scrollbar': {
    width: '6px',
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
  },
  scrollbarWidth: 'thin',
  scrollbarColor: `${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)'} transparent`,
}));

const EditVendor = () => {
  const { id } = useParams();
  const theme = useTheme();
  
const [openSnackbar, setOpenSnackbar] = useState(false);
const [snackbarMessage, setSnackbarMessage] = useState('');
const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [formData, setFormData] = useState({
    vendorCode: '',
    vendorName: '',
    vendorNameArabic: '',
    mobileNo: '',
    email: '',
    trnNo: '',
    countryId: '',
    stateId: '',
    cityId: '',
    poBox: '',
    address: '',
    description: '',
  });

  const navigate = useNavigate();

  // Static data for countries, states, cities, and vendors
  const staticCountryData = [
    { countryId: 1, countryName: 'India' },
  ];

  const staticStateData = [
    { stateId: 1, stateName: 'Bihar' },
    { stateId: 2, stateName: 'Jharkhand' },
  ];

  const staticCityData = [
    { cityId: 1, cityName: 'Patna' },
    { cityId: 2, cityName: 'Ranchi' },
  ];

  const staticVendorData = [
    { vendorId: 1, vendorCode: 'V001', vendorName: 'Vendor One', vendorNameArabic: 'البائع واحد', mobileNo: '1234567890', email: 'vendor.one@example.com', trnNo: 'TRN123', countryId: 1, stateId: 1, cityId: 1, poBox: '12345', address: '123 Main St', description: 'Description for Vendor One' },
    { vendorId: 2, vendorCode: 'V002', vendorName: 'Vendor Two', vendorNameArabic: 'البائع اثنان', mobileNo: '9876543210', email: 'vendor.two@example.com', trnNo: 'TRN456', countryId: 1, stateId: 2, cityId: 2, poBox: '67890', address: '456 Elm St', description: 'Description for Vendor Two' },
    { vendorId: 3, vendorCode: 'V003', vendorName: 'Vendor Three', vendorNameArabic: 'البائع ثلاثة', mobileNo: '5551234567', email: 'vendor.three@example.com', trnNo: 'TRN789', countryId: 1, stateId: 1, cityId: 1, poBox: '54321', address: '789 Oak St', description: 'Description for Vendor Three' },
    { vendorId: 4, vendorCode: 'V004', vendorName: 'Vendor Four', vendorNameArabic: 'البائع أربعة', mobileNo: '4449876543', email: 'vendor.four@example.com', trnNo: 'TRN321', countryId: 1, stateId: 2, cityId: 2, poBox: '98765', address: '321 Pine St', description: 'Description for Vendor Four' },
    { vendorId: 5, vendorCode: 'V005', vendorName: 'Vendor Five', vendorNameArabic: 'البائع خمسة', mobileNo: '7776665555', email: 'vendor.five@example.com', trnNo: 'TRN654', countryId: 1, stateId: 1, cityId: 1, poBox: '13579', address: '654 Cedar St', description: 'Description for Vendor Five' },
    { vendorId: 6, vendorCode: 'V006', vendorName: 'Vendor Six', vendorNameArabic: 'البائع ستة', mobileNo: '3332221111', email: 'vendor.six@example.com', trnNo: 'TRN987', countryId: 1, stateId: 2, cityId: 2, poBox: '24680', address: '987 Birch St', description: 'Description for Vendor Six' },
  ];

  useEffect(() => {
    const vendor = staticVendorData.find(v => v.vendorId === parseInt(id));
    if (vendor) {
      setFormData({
        vendorCode: vendor.vendorCode,
        vendorName: vendor.vendorName,
        vendorNameArabic: vendor.vendorNameArabic,
        mobileNo: vendor.mobileNo,
        email: vendor.email,
        trnNo: vendor.trnNo,
        countryId: vendor.countryId,
        stateId: vendor.stateId,
        cityId: vendor.cityId,
        poBox: vendor.poBox,
        address: vendor.address,
        description: vendor.description,
      });
    }
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSave = (e) => {
    e.preventDefault();
    // Check if all required fields are filled
    if (
      !formData.vendorCode ||
      !formData.vendorName ||
      !formData.mobileNo ||
      !formData.email ||
      !formData.trnNo ||
      !formData.countryId ||
      !formData.stateId ||
      !formData.cityId ||
      !formData.poBox ||
      !formData.address
    ) {
      setSnackbarMessage('plz fill rquired field!');  
  setOpenSnackbar(true);  
  setSnackbarSeverity("error");
      return;
    }

     setShowSuccessModal(true)
  };

  const handleCancel = () => {
    const vendor = staticVendorData.find(v => v.vendorId === parseInt(id));
    if (vendor) {
      setFormData({
        vendorCode: vendor.vendorCode,
        vendorName: vendor.vendorName,
        vendorNameArabic: vendor.vendorNameArabic,
        mobileNo: vendor.mobileNo,
        email: vendor.email,
        trnNo: vendor.trnNo,
        countryId: vendor.countryId,
        stateId: vendor.stateId,
        cityId: vendor.cityId,
        poBox: vendor.poBox,
        address: vendor.address,
        description: vendor.description,
      });
    }
  };

  return (
    <Container maxWidth="lg" sx={{ my: 0 }}>
      <Box
        elevation={3}
        sx={{
          p: 4,
          borderRadius: 2,
          backgroundColor: theme.palette.background.paper,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 3,
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: 'bold', color: theme.palette.primary.main }}>
             Vendor Details
          </Typography>
        </Box>
        {showSuccessModal ? (
          <Modal
            open={showSuccessModal}
            onClose={() => setShowSuccessModal(false)}
            aria-labelledby="success-modal-title"
            aria-describedby="success-modal-description"
            BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
          >
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 400,
                bgcolor: theme.palette.background.paper,
                borderRadius: 2,
                boxShadow: 24,
                overflow: 'hidden',
              }}
            >
              <Box sx={{ backgroundColor: theme.palette.primary.main, padding: '12px 16px' }}>
                <Typography id="success-modal-title" variant="h6" sx={{ color: theme.palette.primary.contrastText }}>
                  Vendor Updated ✅
                </Typography>
              </Box>
              <Box sx={{ padding: '20px' }}>
                <Typography id="success-modal-description" sx={{ mb: 2 }}>
                  Vendor Updated Successfully
                </Typography>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                  <Button
                    onClick={() => {
                      setShowSuccessModal(false);
                      navigate(-1);
                    }}
                    variant="contained"
                    color="primary"
                  >
                    OK
                  </Button>
                </Box>
              </Box>
            </Box>
          </Modal>
        ) : (
          <form onSubmit={handleSave}>
            <TextField
              label="Vendor Code"
              variant="outlined"
              fullWidth
              name="vendorCode"
              value={formData.vendorCode}
              onChange={handleChange}
              sx={{
                mb: 3,
                '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                '& .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.text.primary },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.primary.main },
              }}
            />
            <TextField
              label="Vendor Name"
              variant="outlined"
              fullWidth
              name="vendorName"
              value={formData.vendorName}
              onChange={handleChange}
              sx={{
                mb: 3,
                '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                '& .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.text.primary },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.primary.main },
              }}
            />
            <TextField
              label="Vendor Name (Arabic)"
              variant="outlined"
              fullWidth
              name="vendorNameArabic"
              value={formData.vendorNameArabic}
              onChange={handleChange}
              sx={{
                mb: 3,
                '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                '& .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.text.primary },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.primary.main },
              }}
            />
            <TextField
              label="Mobile No."
              variant="outlined"
              fullWidth
              name="mobileNo"
              value={formData.mobileNo}
              onChange={handleChange}
              sx={{
                mb: 3,
                '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                '& .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.text.primary },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.primary.main },
              }}
            />
            <TextField
              label="Email"
              variant="outlined"
              fullWidth
              name="email"
              value={formData.email}
              onChange={handleChange}
              sx={{
                mb: 3,
                '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                '& .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.text.primary },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.primary.main },
              }}
            />
            <TextField
              label="TRN No."
              variant="outlined"
              fullWidth
              name="trnNo"
              value={formData.trnNo}
              onChange={handleChange}
              sx={{
                mb: 3,
                '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                '& .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.text.primary },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.primary.main },
              }}
            />
            <FormControl
              fullWidth
              sx={{
                mb: 3,
                '& .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.text.primary },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.primary.main },
              }}
            >
              <InputLabel
                id="country-label"
                sx={{ color: theme.palette.text.primary, '&.Mui-focused': { color: theme.palette.primary.main } }}
              >
                Country
              </InputLabel>
              <Select
                labelId="country-label"
                id="country"
                name="countryId"
                value={formData.countryId}
                label="Country"
                onChange={handleChange}
                sx={{
                  '& .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.text.primary },
                  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.primary.main },
                }}
              >
                {staticCountryData.map((countryItem) => (
                  <MenuItem key={countryItem.countryId} value={countryItem.countryId}>
                    {countryItem.countryName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl
              fullWidth
              sx={{
                mb: 3,
                '& .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.text.primary },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.primary.main },
              }}
            >
              <InputLabel
                id="state-label"
                sx={{ color: theme.palette.text.primary, '&.Mui-focused': { color: theme.palette.primary.main } }}
              >
                State
              </InputLabel>
              <Select
                labelId="state-label"
                id="state"
                name="stateId"
                value={formData.stateId}
                label="State"
                onChange={handleChange}
                sx={{
                  '& .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.text.primary },
                  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.primary.main },
                }}
              >
                {staticStateData.map((stateItem) => (
                  <MenuItem key={stateItem.stateId} value={stateItem.stateId}>
                    {stateItem.stateName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl
              fullWidth
              sx={{
                mb: 3,
                '& .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.text.primary },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.primary.main },
              }}
            >
              <InputLabel
                id="city-label"
                sx={{ color: theme.palette.text.primary, '&.Mui-focused': { color: theme.palette.primary.main } }}
              >
                City
              </InputLabel>
              <Select
                labelId="city-label"
                id="city"
                name="cityId"
                value={formData.cityId}
                label="City"
                onChange={handleChange}
                sx={{
                  '& .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.text.primary },
                  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.primary.main },
                }}
              >
                {staticCityData.map((cityItem) => (
                  <MenuItem key={cityItem.cityId} value={cityItem.cityId}>
                    {cityItem.cityName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              label="PO Box"
              variant="outlined"
              fullWidth
              name="poBox"
              value={formData.poBox}
              onChange={handleChange}
              sx={{
                mb: 3,
                '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                '& .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.text.primary },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.primary.main },
              }}
            />
            <TextField
              label="Address"
              variant="outlined"
              fullWidth
              name="address"
              value={formData.address}
              onChange={handleChange}
              sx={{
                mb: 3,
                '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                '& .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.text.primary },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.primary.main },
              }}
            />
            <TextField
              label="Description"
              variant="outlined"
              fullWidth
              name="description"
              value={formData.description}
              onChange={handleChange}
              sx={{
                mb: 3,
                '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                '& .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.text.primary },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.primary.main },
              }}
            />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
              <Tooltip
                title={
                  (!formData.vendorCode && 'Enter Vendor Code') ||
                  (!formData.vendorName && 'Enter Vendor Name') ||
                  (!formData.mobileNo && 'Enter Mobile No.') ||
                  (!formData.email && 'Enter Email') ||
                  (!formData.trnNo && 'Enter TRN No.') ||
                  (!formData.countryId && 'Select Country') ||
                  (!formData.stateId && 'Select State') ||
                  (!formData.cityId && 'Select City') ||
                  (!formData.poBox && 'Enter PO Box') ||
                  (!formData.address && 'Enter Address')
                }
                arrow
              >
                <span>
                  <Button
                    variant="contained"
                    type="submit"
                    disabled={
                      !formData.vendorCode ||
                      !formData.vendorName ||
                      !formData.mobileNo ||
                      !formData.email ||
                      !formData.trnNo ||
                      !formData.countryId ||
                      !formData.stateId ||
                      !formData.cityId ||
                      !formData.poBox ||
                      !formData.address
                    }
                  >
                    Update
                  </Button>
                </span>
              </Tooltip>
              <Button
                variant="outlined"
                color="error"
                onClick={()=>{navigate(-1)}}
               data-app-cancel="true">
                Cancel
              </Button>
            </Box>
          </form>
        )}
      </Box>
      <Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>
    </Container>
  );
};

export default EditVendor;